<template>
  <!-- 法律服务面对面-律师地图 -->
  <div class="inner-content">
    <h3 class="titleh3">法律服务面对面</h3>
    <div class="appoint-btns">
      <a @click="gotoLawyer(1)">预约省总工会职工法律援助律师</a>
      <a @click="gotoLawyer(2)">预约设区市总工会职工法律援助律师</a>
    </div>
    <div class="area-box">
      <div class="left-area">
        <img src="@/assets/images/map.png" alt="" />
        <ul class="area-list">
          <li
            class="area-item"
            :class="item.eName"
            v-for="(item, index) in cityList"
            :key="index"
            v-show="cityActiveIndex === index"
          >
            <p>{{ item.name }}</p>
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>
      <div class="right-areachose">
        <!-- <img src="@/assets/images/area.png" alt=""> -->
        <swiper ref="mySwiper" :options="swiperOptions" class="swiper-cont">
          <swiper-slide
            v-for="(item, index) in cityList"
            :key="index"
            @touchEnd="touchEnd"
          >
            <div class="city-name">{{ item.name }}</div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import { getLawyerServiceList } from '@/api/index';
export default {
  name: 'LawyerArea',
  data() {
    let self = this;
    return {
      swiperOptions: {
        direction: 'vertical', // 控制轮播方向
        slidesPerView: 5,  // 默认显示5个选项
        centeredSlides: true, // 选中默认在中间
        loop: true,
        on: {
          slideChangeTransitionEnd() {
            self.cityActiveIndex = Number(this.activeIndex - 5);
            if (self.cityActiveIndex === -1) {
              self.cityActiveIndex = 12;
            } else if (self.cityActiveIndex == 13) {
              self.cityActiveIndex = 0;
            }
          },
        },
      },
      cityActiveIndex: 1,
      cityList: [
        {
          name: '南京',
          eName: 'nanjing',
          imgUrl: require('@/assets/images/map/nanjing.png'),
        },
        {
          name: '无锡',
          eName: 'wuxi',
          imgUrl: require('@/assets/images/map/wuxi.png'),
        },
        {
          name: '徐州',
          eName: 'xuzhou',
          imgUrl: require('@/assets/images/map/xuzhou.png'),
        },
        {
          name: '常州',
          eName: 'changzhou',
          imgUrl: require('@/assets/images/map/changzhou.png'),
        },
        {
          name: '苏州',
          eName: 'suzhou',
          imgUrl: require('@/assets/images/map/suzhou.png'),
        },
        {
          name: '南通',
          eName: 'nantong',
          imgUrl: require('@/assets/images/map/nantong.png'),
        },
        {
          name: '连云港',
          eName: 'lianyungang',
          imgUrl: require('@/assets/images/map/lianyungang.png'),
        },
        {
          name: '淮安',
          eName: 'huaian',
          imgUrl: require('@/assets/images/map/huaian.png'),
        },
        {
          name: '盐城',
          eName: 'yancheng',
          imgUrl: require('@/assets/images/map/yancheng.png'),
        },
        {
          name: '扬州',
          eName: 'yangzhou',
          imgUrl: require('@/assets/images/map/yangzhou.png'),
        },
        {
          name: '镇江',
          eName: 'zhenjiang',
          imgUrl: require('@/assets/images/map/zhenjiang.png'),
        },
        {
          name: '泰州',
          eName: 'taizhou',
          imgUrl: require('@/assets/images/map/taizhou.png'),
        },
        {
          name: '宿迁',
          eName: 'suqian',
          imgUrl: require('@/assets/images/map/suqian.png'),
        },
      ],
    };
  },
  mounted() {
    this.getLawyerServiceList();
  },
  methods: {
    getLawyerServiceList() {
      getLawyerServiceList().then((res) => {
        console.log(res);
      });
    },
    gotoLawyer(num) {
      this.$router.push({ name: 'Lawyer', query: { type: num } });
    },
    touchEnd(a, b) {
      // console.log('hhhhhhhhhhhhhhhhh')
      console.log('a', a);
      console.log('b', b);
    },
  },
};
</script>
<style scoped>
.inner-content {
  padding: 0 20px;
}
.appoint-btns {
  display: flex;
  justify-content: space-between;
  padding-bottom: 26px;
  border-bottom: 1px solid #5e9af5;
}
.appoint-btns a {
  display: inline-block;
  width: 560px;
  height: 95px;
  line-height: 95px;
  font-size: 28px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  box-sizing: content-box;
}
.appoint-btns a:first-child {
  background: url('~@/assets/images/btn-bg1.png') no-repeat;
  background-size: 100% 100%;
}
.appoint-btns a:last-child {
  background: url('~@/assets/images/btn-bg2.png') no-repeat;
  background-size: 100% 100%;
}
.area-box {
  min-height: 615px;
  background: url('~@/assets/images/map-bg.png') no-repeat;
  background-position: center bottom;
  margin-bottom: 80px;
  display: flex;
}
.left-area {
  width: 437px;
  height: 525px;
  margin: 90px 0 0 280px;
  position: relative;
}
.right-areachose {
  margin-top: 140px;
  margin-left: 100px;
  height: 400px;
}
.swiper-cont {
  width: 330px;
  height: 400px;
}
.swiper-slide {
  /* height: 110px !important; */
  text-align: center;
  line-height: 87px;
  font-size: 16px;
  color: #7c7c7c;
}
.city-name {
  line-height: 70px;
}
.swiper-slide.swiper-slide-active {
  color: #2466ca;
  background: url('~@/assets/images/city-bg.png') no-repeat;
}
.area-list {
  list-style: none;
  position: absolute;
  height: 525px;
  width: 437px;
  top: 0;
}
.area-list .area-item {
  font-size: 19px;
  color: #1e57a8;
  /* text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0; */
}
.area-list .area-item.changzhou img {
  position: absolute;
  bottom: 88px;
  right: 150px;
}
.area-list .area-item.huaian img {
  position: absolute;
  bottom: 259px;
  right: 162px;
}
.area-list .area-item.lianyungang img {
  position: absolute;
  top: 23px;
  right: 135px;
}
.area-list .area-item.nanjing img {
  position: absolute;
  bottom: 102px;
  right: 228px;
}
.area-list .area-item.nantong img {
  position: absolute;
  bottom: 104px;
  left: 296px;
}
.area-list .area-item.suqian img {
  position: absolute;
  top: 92px;
  left: 114px;
}
.area-list .area-item.xuzhou img {
  position: absolute;
  top: 0px;
  left: 3px;
}
.area-list .area-item.yancheng img {
  position: absolute;
  top: 98px;
  right: 71px;
}
.area-list .area-item.suzhou img {
  position: absolute;
  bottom: 32px;
  right: 55px;
}
.area-list .area-item.wuxi img {
  position: absolute;
  bottom: 81px;
  right: 119px;
}
.area-list .area-item.taizhou img {
  position: absolute;
  bottom: 156px;
  right: 119px;
}
.area-list .area-item.yangzhou img {
  position: absolute;
  bottom: 191px;
  right: 162px;
}
.area-list .area-item.zhenjiang img {
  position: absolute;
  bottom: 139px;
  right: 166px;
}
.area-list .area-item p {
  position: absolute;
  min-width: 50px;
  z-index: 99;
  color: #fff;
}
.area-list .area-item.changzhou p {
  left: 211px;
  bottom: 103px;
}
.area-list .area-item.huaian p {
  top: 172px;
  left: 205px;
}
.area-list .area-item.lianyungang p {
  top: 67px;
  left: 221px;
}
.area-list .area-item.nanjing p {
  bottom: 153px;
  left: 146px;
}
.area-list .area-item.nantong p {
  bottom: 145px;
  right: 50px;
}
.area-list .area-item.suqian p {
  top: 122px;
  left: 164px;
}
.area-list .area-item.xuzhou p {
  top: 73px;
  left: 101px;
}
.area-list .area-item.yancheng p {
  top: 188px;
  right: 96px;
}
.area-list .area-item.suzhou p {
  left: 306px;
  bottom: 55px;
}
.area-list .area-item.wuxi p {
  left: 267px;
  bottom: 87px;
}
.area-list .area-item.taizhou p {
  left: 268px;
  bottom: 169px;
}
.area-list .area-item.yangzhou p {
  left: 219px;
  bottom: 206px;
}
.area-list .area-item.zhenjiang p {
  left: 203px;
  bottom: 146px;
}
</style>
